import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setContentLoading, setFilter, setDateFilter, setFieldFilter } from "../../store/reducers/CommonReducer"
import { getOxeOPList, getOxeOPTableSchema } from "../../store/actions/OxeActions"
import TextField from "../common/TextField"
import { SearchOutlined } from "@ant-design/icons"
import { getTranslated } from "../../utils/CommonUtils"
import CustomTable from "../common/CustomTable"
import UMCButton from "../common/UMCButton"
import { setLogFilteredList } from "../../store/reducers/OxeReducer"
import { useWindowSize } from "../customHooks/useWindowSize"
import { DatePicker, Button } from "antd"
import _ from "lodash"
import { OXE_OP_URL } from "../../utils/Config"
import { CC_PRODUCT_ID } from "../../utils/Constants"
import { getSessionItem } from "../../utils/storageUtils"
import { getExportData } from "../../store/actions/CommonActions"
import { setPageFromIndex } from "../../store/reducers/CommonReducer"

const dateFilters = {
    DAY: "1D",
    WEEK: "1W",
    CUSTOM: "CUSTOM"
}

const OxeLog = () => {

    const [selectedDateFilter, setSelectedDateFilter] = useState("")
    const [dateRange, setDateRange] = useState(null);

    const logTableSchema = useSelector(state => state.oxe.logTableSchema)
    const logFilteredList = useSelector(state => state.oxe.logFilteredList)
    const logTableList = useSelector(state => state.oxe.logTableList)
    const dict = useSelector(state => state.common.dict)
    const reduxDateFilter = useSelector(state => state.common.dateFilter)
    const language = useSelector(state => state.common.language)

    const dispatch = useDispatch()
    const [width, height] = useWindowSize()

    useEffect(() => {
        // Clear date filter selection
        dispatch(setDateFilter(""))
        dispatch(setFilter(""))
        dispatch(setFieldFilter(""))
        dispatch(setContentLoading(true))
        dispatch(getOxeOPTableSchema())
        dispatch(getOxeOPList())
    }, [dispatch])

    useEffect(() => {
        if (logTableSchema?.length && logTableList)
            dispatch(setContentLoading(false))
    }, [logTableSchema, logTableSchema])

    // Adding this effect to update local state when the Redux date filter is cleared.
    useEffect(() => {
        if (reduxDateFilter === "") {
            setSelectedDateFilter("");
            setDateRange("");
        }
    }, [reduxDateFilter])

    // Debounced search function 
    const debouncedSearch = _.debounce((value) => {
        if (!value) {
            dispatch(setFilter(value))
            dispatch(getOxeOPList());
        } else if (value.length >= 3) {
            dispatch(setFilter(value))
            dispatch(setContentLoading(true))
            dispatch(setPageFromIndex(0))
            dispatch(getOxeOPList())
        }
    }, 300)

    const getModalTitle = ({ id, time }) => {
        return (<div
            className="modal-title-container"
        >
            <div className="modal-title-value">
                <span className="modal-title">{"Creation SIP Trunk OVH"}</span>
                <span>{time}</span>
            </div>
            <UMCButton
                type="primary"
                title="Export the status"
                label= {getTranslated(dict,"LABEL_EXPORT_THE_STATUS")}
                onClick={() => handleDetailedExport(id)}
            >
            </UMCButton>
        </div>
        )

    }

    const handleDateFilterSelect = (val) => {

        if (selectedDateFilter === val) {
            // If the clicked button is already active, deactivate it
            setSelectedDateFilter("");
            setDateRange(null);
            dispatch(setDateFilter(""));
            dispatch(getOxeOPList());
            return;
        }
        setSelectedDateFilter(val)

        if (val === dateFilters.DAY || val === dateFilters.WEEK) {
            setDateRange(null);
        }

        if (val === dateFilters.DAY) {
            const currentDate = new Date();
            const oneDayAgo = new Date(currentDate);
            oneDayAgo.setDate(currentDate.getDate() - 1);

            const startDate = formatCustomDateRange(oneDayAgo);
            const endDate = formatCustomDateRange(currentDate);

            const oneDayFilter = `[${startDate},${endDate}]`;
            dispatch(setDateFilter(oneDayFilter));
        }

        else if (val === dateFilters.WEEK) {
            const currentDate = new Date();
            const oneWeekAgo = new Date(currentDate);
            oneWeekAgo.setDate(currentDate.getDate() - 7);

            const startDate = formatCustomDateRange(oneWeekAgo);
            const endDate = formatCustomDateRange(currentDate);

            const oneWeekFilter = `[${startDate},${endDate}]`;
            dispatch(setDateFilter(oneWeekFilter));
        } else {
            dispatch(setDateFilter(""));
        }
        dispatch(setContentLoading(true))
        dispatch(getOxeOPList());
    }

    const formatCustomDateRange = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const now = new Date();

        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        const formattedTime = `${hours}:${minutes}:${seconds}`;
        return `${year}/${month}/${day} ${formattedTime}`;
    };

    const handleCstmFilterChange = (date, dateString) => {
        setSelectedDateFilter("");
        if (!date) {
            dispatch(setDateFilter(""));
            dispatch(getOxeOPList());
        } else if (date && date.length === 2) {
            const formattedStartDate = formatCustomDateRange(date[0].toDate());
            const formattedEndDate = formatCustomDateRange(date[1].toDate());
            const customDateRange = `[${formattedStartDate},${formattedEndDate}]`;
            setDateRange(date);
            dispatch(setDateFilter(customDateRange))
            dispatch(setContentLoading(true))
            dispatch(getOxeOPList())
        }
    }


    const getTableHeader = () => {

        return <div className="inner-tab-hd-container">
            <TextField
                handleChange={(value) => {
                    debouncedSearch(value)
                }}
                className="user-search"
                prefix={<SearchOutlined classID="modal-export-button" />}
                placeholder={getTranslated(dict, "LABEL_SEARCH")}
            />

            <UMCButton label={getTranslated(dict, "LABEL_EXPORT")} type="primary" className="cont-header-btn" onClick={() => handleGlobalExport()} />

            <div className="date-sel-gp">
                <UMCButton label={getTranslated(dict, "LABEL_1_DAY")} onClick={() => handleDateFilterSelect(dateFilters.DAY)} type={selectedDateFilter === "1D" ? "primary" : ""} />
                <UMCButton label={getTranslated(dict, "LABEL_1_WEEK")} onClick={() => handleDateFilterSelect(dateFilters.WEEK)} type={selectedDateFilter === dateFilters.WEEK ? "primary" : ""} />
                <DatePicker.RangePicker
                    format="YYYY/MM/DD"
                    locale={language}
                    placeholder={[getTranslated(dict, "PH_START_DATE"), getTranslated(dict, "PH_END_DATE")]}
                    onChange={handleCstmFilterChange}
                    value={dateRange}
                    allowClear
                />
            </div>
        </div>
    }

    const handleDetailedExport = async (timeStamp) => {
        const apiUrl = `${OXE_OP_URL}/data/list/oxeoperation/${getSessionItem(CC_PRODUCT_ID)}/${timeStamp}/export?fields=[object,operation,index,value,status]`
        dispatch(getExportData(apiUrl))
    }

    const handleGlobalExport = async () => {
        const apiUrl = `${OXE_OP_URL}/data/list/oxeoperation/${getSessionItem(CC_PRODUCT_ID)}/export?fields=[name,timestamp,description]`

        dispatch(getExportData(apiUrl))
    };

    const getTable = () => {

        return <CustomTable
            schema={logTableSchema}
            filteredData={logFilteredList}
            tableData={logTableList}
            updateTableAction={setLogFilteredList}
            height={height <= 585 ? "19em" : "59vh"}
            isDynamicAction={true}
            closable={true}
            fetchData={getOxeOPList}
            titleRenderer={getModalTitle}
            detailedDataAPI={`${OXE_OP_URL}/data/list/oxeoperation/${getSessionItem(CC_PRODUCT_ID)}`}
        />
    }


    return <div id="inner-tab-content">
        <div style={{ marginBottom: "14px" }}>
            {getTableHeader()}
        </div>
        {getTable()}
    </div>
}

export default OxeLog